import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALDOI_LOAD_BY_TRIAL_ID,
    ACTION_TRIALDOI_LOAD_BY_ID,

    ACTION_TRIALDOI_SAVE,

    ACTION_TRIALDOI_CREATE,

    ACTION_TRIALDOI_VALIDATE,

    ITrialDoiLoadByTrialIdAction,
    ITrialDoiLoadByIdAction,
    ITrialDoiLoadFailureAction,
    ITrialDoiLoadSuccessAction,

    ITrialDoiSaveAction,
    ITrialDoiSaveSuccessAction,
    ITrialDoiSaveFailureAction,

    ITrialDoiCreateAction,
    ITrialDoiCreateSuccessAction,
    ITrialDoiCreateFailureAction,

    ITrialDoiValidateAction,
    ITrialDoiValidateSuccessAction,
    ITrialDoiValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialDoi";
import { trialDoiApi } from "../services/trialDoi";

export const
    getTrialDoiByTrialIdEpic = (action$): Observable<ITrialDoiLoadSuccessAction | ITrialDoiLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALDOI_LOAD_BY_TRIAL_ID)
            .mergeMap((action: ITrialDoiLoadByTrialIdAction) => {
                return trialDoiApi
                    .getTrialDoiByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialDoi, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialDoiByIdEpic = (action$): Observable<ITrialDoiLoadSuccessAction | ITrialDoiLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALDOI_LOAD_BY_ID)
            .mergeMap((action: ITrialDoiLoadByIdAction) => {
                return trialDoiApi
                    .getTrialDoiById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialDoi, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialDoiEpic = (action$): Observable<ITrialDoiSaveSuccessAction | ITrialDoiSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALDOI_SAVE)
            .mergeMap((action: ITrialDoiSaveAction) => {
                return trialDoiApi
                    .setTrialDoi(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialDoi, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialDoiEpic = (action$): Observable<ITrialDoiCreateSuccessAction | ITrialDoiCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALDOI_CREATE)
            .mergeMap((action: ITrialDoiCreateAction) => {
                return trialDoiApi
                    .createTrialDoi(action.trialId)
                    .map(response =>
                        CreateSuccess(
                            response.trialDoi,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialDoiEpic = (action$): Observable<ITrialDoiValidateSuccessAction | ITrialDoiValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALDOI_VALIDATE)
            .mergeMap((action: ITrialDoiValidateAction) => {
                return trialDoiApi
                    .validateTrialDoi(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialDoi, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }